import styled from 'styled-components'

export const DragHandle = styled.div`
  display: flex;
  align-items: center;
  align-self: stretch;
  flex-grow: 0;
  flex-shrink: 0;
  visibility: hidden;
  .fa-grip-vertical {
    margin: 0.1rem 0.45rem 0 0.45rem;
    color: ${({ theme }) => theme.textGreyTintedLighterInverse};
    font-size: 0.75rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`
